import styled from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

export const PageRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme: { colors } }) => colors.surface};
`;

export const PageBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 32px 28px;

  @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
    padding: 20px 16px;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(300px, 100%), 1fr));
  gap: ${({ theme: { spacing } }) => spacing.level5};
  max-width: 1320px;
`;

export const StateWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 64px 0;
`;
